import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/solutions/page.tsx");
